import {filter, get, map, some} from 'lodash';
import React, {useContext} from 'react';

const FormattersContext = React.createContext([]);

function useFormatters() {
    const {formatters} = useContext(FormattersContext);
    return formatters;
}

function useIndexedFormatters() {
    const {formatterById} = useContext(FormattersContext);
    return formatterById;
}

function useFormatterById(formatterId) {
    const {formatterById} = useContext(FormattersContext);
    return get(formatterById, formatterId, null);
}

function useListFormatterByType(dataTypeId) {
    const {listFormatterByType} = useContext(FormattersContext);
    return get(listFormatterByType, dataTypeId, null);
}

function usePopupPluginFormattersByTypeAndPage(dataTypeId, pageFormatter) {
    const {popupPluginFormatterByType} = useContext(FormattersContext);
    const popupFormattersForType = get(popupPluginFormatterByType, dataTypeId, []);
    return filter(popupFormattersForType, (popupFormatter) =>
        some(pageFormatter.settings?.popups, {id: popupFormatter.id}),
    );
}

function useCreateFormatterByType(dataTypeId) {
    const {createFormatterByType} = useContext(FormattersContext);
    return get(createFormatterByType, dataTypeId, null);
}

function useEditFormattersByType(dataTypeId) {
    const {editFormattersByType} = useContext(FormattersContext);
    return get(editFormattersByType, dataTypeId, null);
}

function useDetailFormattersByType(dataTypeId) {
    const {detailFormattersByType} = useContext(FormattersContext);
    return get(detailFormattersByType, dataTypeId, null);
}

function useFormattersByDataType(dataTypeId) {
    const {formattersByType} = useContext(FormattersContext);
    return get(formattersByType, dataTypeId, null);
}

function useFormattersByIds(formatterIds) {
    const {formatterById} = useContext(FormattersContext);

    return map(formatterIds, (id) => formatterById[id]);
}

export default FormattersContext;

export {
    FormattersContext,
    useCreateFormatterByType,
    useDetailFormattersByType,
    useEditFormattersByType,
    useFormatterById,
    useFormatters,
    useFormattersByDataType,
    useFormattersByIds,
    useIndexedFormatters,
    useListFormatterByType,
    usePopupPluginFormattersByTypeAndPage,
};
